import * as API_CONSTANT from "../constants";

export const getAllPrivilege = () =>
    fetch(`${API_CONSTANT.cnp_v1_fe_path}/privilege/get/all`, {
        method: "POST",
        headers: API_CONSTANT.headers,
        body: JSON.stringify({}),
    }).then((res) => res.json())